import { PermissionCodeEnum } from '@models/permission'
import { UserInfo } from '@models/user.model'

export const hasPermission = (
	userInfo: UserInfo | undefined,
	codes: PermissionCodeEnum[],
	project_id?: string,
) => {
	if (userInfo === undefined) return false
	if (userInfo.is_super_admin) return true

	console.debug('hasPermission: userInfo.role_permission', userInfo.role_permissions)
	console.debug('hasPermission: project_id', project_id)
	console.debug('hasPermission: codes', codes)

	const pass =
		userInfo.role_permissions?.some(
			(x) =>
				(project_id === undefined || x.project_id === project_id) &&
				(x.is_admin ||
					codes.some((y) => {
						return x.permissions.indexOf(y) > -1
					})),
		) ?? false

	return pass
}
